<mat-list>
    @if(autitTrail().userDisplayName){    
        <mat-list-item>
            <span matListItemIcon><mat-icon>person</mat-icon></span>
            <span matListItemTitle>{{ 'auditTrail.creator' | translate }}</span>
            <span matListItemLine>{{autitTrail().userDisplayName}}</span>
        </mat-list-item>
        <mat-list-item>
            <span matListItemIcon><mat-icon>calendar_today</mat-icon></span>
            <span matListItemTitle>{{ 'auditTrail.createDate' | translate }}</span>
            <span matListItemLine>{{autitTrail().createDate | date: 'yyyy-MM-dd HH:mm:ss'}}</span>
        </mat-list-item>
    }
    @if(autitTrail().editorDisplayName){
        <mat-list-item>
            <span matListItemIcon><mat-icon>person_edit</mat-icon></span>
            <span matListItemTitle>{{ 'auditTrail.editor' | translate }}</span>
            <span matListItemLine>{{autitTrail().editorDisplayName}}</span>
        </mat-list-item>
        <mat-list-item>
            <span matListItemIcon><mat-icon>edit_calendar</mat-icon></span>
            <span matListItemTitle>{{ 'auditTrail.editDate' | translate }}</span>
            <span matListItemLine>{{autitTrail().editDate | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
        </mat-list-item>
    }
</mat-list>
    @if(autitTrail().entity){
        <div class="center">
            <button matButton="tonal" (click)="showHistory()">
                <mat-icon>history</mat-icon>
                {{ 'auditTrail.changeHistory' | translate }}
            </button>
        </div>
    }